import type { ReactNode } from 'react';
import { navyGradient, tokens } from './tokens';

type Props = Readonly<{
  title: string;
  subtitle?: string;
  children: ReactNode;
}>;

/**
 * Opinionated form container. Centers the form on a navy gradient page
 * background, renders the QMI brand mark, and applies the canonical
 * white card styling. No customization knobs — every form looks identical.
 */
export function FormCard({ title, subtitle, children }: Props): JSX.Element {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-8"
      style={{ background: navyGradient }}
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center text-xs font-black"
            style={{ background: `linear-gradient(135deg, ${tokens.gold}, ${tokens.goldLight})`, color: tokens.navy }}
          >
            QMI
          </div>
          <span className="text-xs uppercase tracking-[2px]" style={{ color: tokens.gold }}>
            Investor Portal
          </span>
        </div>

        <div
          className="rounded-2xl p-9"
          style={{ background: tokens.surface, boxShadow: '0 32px 80px rgba(0,0,0,0.45)' }}
        >
          <h2 className="text-2xl font-bold mb-1" style={{ color: tokens.textPrimary }}>
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm mb-7" style={{ color: tokens.textPlaceholder }}>
              {subtitle}
            </p>
          )}
          <div className="space-y-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
